import React from 'react';
import { Clock, Plus, Edit, Lock, Unlock, ArrowRight, PenTool, MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatActivityTime, formatActivityMessage } from '../../../utils/mockActivityLogData';
import './ActivityLog.css';

const activityIcons = {
  created: Plus,
  edited: Edit,
  autosaved: Edit,
  updated: Edit,
  locked: Lock,
  unlocked: Unlock,
  status_changed: ArrowRight,
  signed: PenTool,
  commented: MessageSquare,
  comment_added: MessageSquare,
  document_uploaded: MessageSquare,
  module_completed: PenTool,
};

export function ActivityLog({ activities = [] }) {
  const { t } = useTranslation();
  if (activities.length === 0) {
    return (
      <div className="activity-log">
        <div className="activity-log__empty">
          <Clock size={48} className="activity-log__empty-icon" />
          <h3 className="activity-log__empty-title">{t('reports.workspace.activityLog.empty')}</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-log">
      <div className="activity-log__list">
        {activities.map((activity) => {
          const Icon = activityIcons[activity.action] || Clock;
          const message = formatActivityMessage(activity, t);

          return (
            <div key={activity.id} className="activity-log__item">
              <div className="activity-log__item-icon">
                <Icon size={18} />
              </div>
              <div className="activity-log__item-content">
                <div className="activity-log__item-action">{message}</div>
                <div className="activity-log__item-user">{activity.userName || activity.user || t('reports.workspace.fallback.unknown')}</div>
                <div className="activity-log__item-time">
                  {formatActivityTime(activity.timestamp, t)}
                </div>
                {activity.details && (
                  <div className="activity-log__item-details">
                    {typeof activity.details === 'string' ? (
                      activity.details
                    ) : (
                      <>
                        {activity.details.changes && (
                          <div className="activity-log__item-changes">
                            <strong>{t('reports.workspace.activityLog.changesLabel')}:</strong>
                            <ul>
                              {activity.details.changes.map((change, index) => (
                                <li key={index}>{change}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {activity.details.reason && (
                          <div className="activity-log__item-reason">
                            <strong>{t('reports.workspace.activityLog.reasonLabel')}:</strong> {activity.details.reason}
                          </div>
                        )}
                        {activity.details.targetName && (
                          <div>{activity.details.targetName}</div>
                        )}
                        {activity.details.oldStatus && activity.details.newStatus && (
                          <div>
                            {t('reports.workspace.activityLog.statusChangedFrom')}{' '}
                            <strong>{t(`reports.status.${activity.details.oldStatus}`, { defaultValue: activity.details.oldStatus })}</strong>{' '}
                            {t('reports.workspace.activityLog.to')}{' '}
                            <strong>{t(`reports.status.${activity.details.newStatus}`, { defaultValue: activity.details.newStatus })}</strong>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
